import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c84bfa48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 人员选择器 ")
const _hoisted_3 = { class: "filterbox" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "username" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_van_field, {
      class: "field",
      modelValue: _ctx.fieldValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fieldValue) = $event)),
      "is-link": "",
      readonly: "",
      rules: [{ required: true, message: '请选择处理人' }],
      required: "",
      name: "picker",
      label: "处理人",
      placeholder: "请选择处理人",
      onClick: _ctx.showPopup
    }, null, 8, ["modelValue", "onClick"]),
    _createVNode(_component_van_popup, {
      show: _ctx.show,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.show) = $event)),
      position: "bottom",
      round: "",
      style: { height: '95%' },
      class: "popup"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("span", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
          }, [
            _createVNode(_component_van_icon, { name: "cross" })
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_van_search, {
            modelValue: _ctx.personName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.personName) = $event)),
            placeholder: "搜索"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_van_pull_refresh, {
            modelValue: _ctx.refreshing,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.refreshing) = $event)),
            onRefresh: _ctx.onRefresh
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_list, {
                loading: _ctx.loading,
                "onUpdate:loading": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.loading) = $event)),
                finished: _ctx.finished,
                "finished-text": "没有更多了",
                onLoad: _ctx.onLoad
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_radio_group, {
                    modelValue: _ctx.result,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.result) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_cell_group, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkList, (item, index) => {
                            return (_openBlock(), _createBlock(_component_van_radio, {
                              key: index,
                              name: item,
                              modelValue: item.userId,
                              "onUpdate:modelValue": ($event: any) => ((item.userId) = $event)
                            }, {
                              default: _withCtx(() => [
                                (item.photoUrl)
                                  ? (_openBlock(), _createElementBlock("img", {
                                      key: 0,
                                      class: "img",
                                      src: item.photoUrl
                                    }, null, 8, _hoisted_5))
                                  : _createCommentVNode("", true),
                                _createElementVNode("span", _hoisted_6, _toDisplayString(item.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["name", "modelValue", "onUpdate:modelValue"]))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["loading", "finished", "onLoad"])
            ]),
            _: 1
          }, 8, ["modelValue", "onRefresh"])
        ]),
        _createVNode(_component_van_button, {
          style: _normalizeStyle({ backgroundColor: _ctx.flag === true ? '#3f55f4' : '#9fabfe' }),
          block: "",
          type: "primary",
          onClick: _ctx.onFinish
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["style", "onClick"])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}